// module.depth-safety (contract §4.8.1): DepthSafetyModule
// (UnderwayModules.tsx): the depth at the extra-large readout, red at or under
// the shallow line, with the shoaling note, the stale note, the shallow line
// in words, and the seabed trace of the last minutes (stepped, on [0, the
// deepest, twice the shallow line or 5 m], the shallow line dashed across it),
// hidden under three points.
//
// Where the page differs: the trace's shallow line carries no "Shallow alarm"
// label, which the typed-in rule reads as a raised alarm (§9.4); the line in
// words above it says where it is.

import { css, h } from "./kit.js";
import { F, S } from "./module-kit.js";

export function moduleDepthSafety() {
  const series = {
    "data-tc-y": "feed",
    "data-tc-group": "d",
    "data-tc-curve": "step",
    "data-tc-inset": "3 1 3 1",
  };
  return {
    lane: true,
    kind: true,
    html: [
      h(
        "div",
        { class: "rd dp-r" },
        h(
          "span",
          { class: "rd-row rd-xl" },
          h("span", { class: "rd-v dp-v", ...F("depth") }),
          h("span", { class: "rd-u", ...F("depth-unit") }),
        ),
        h("span", { class: "mo-sub", ...F("note") }),
      ),
      h("p", { class: "dp-st", ...F("stale") }),
      h("p", { class: "dp-th", ...F("shallow") }),
      h("i", { class: "mo-flag", ...F("trace") }),
      h(
        "svg",
        {
          class: "mo-lane dp-tr",
          "data-tc-fit": "trace",
          "data-tc-window": "feed:module.depth",
          "aria-hidden": "true",
        },
        h("path", { class: "ln", ...S("depth", series) }),
        h("line", { class: "dp-sl", x2: 1, ...F("shallow-line") }),
      ),
    ],
    css: css(`
      .mo-depth-safety { min-height: 0; padding-top: 9px; }
      .dp-v { font-weight: 700; }
      .dp-v[data-tone=bad] { color: var(--danger); }
      .dp-v[data-quality=stale], .dp-v[data-quality=missing] { color: var(--muted); }
      /* At night a stale value keeps the text colour: grey under the night tint reads below the app's own values (§9.6, TOM-665). */
      html[data-theme=night] .dp-v[data-quality=stale] { color: var(--text); }
      .dp-st { margin-top: 4px; font-size: 14px; font-weight: 600; color: var(--muted); font-variant-numeric: tabular-nums; }
      .dp-th { margin-top: 4px; font-size: 12px; color: var(--muted); }
      .dp-st:empty, .dp-th:empty { display: none; }
      .dp-tr { margin-top: 8px; min-height: 64px; height: 72px; flex: 1 1 auto; }
      .mo-flag[data-state=hidden] ~ .dp-tr { display: none; }
      .dp-tr .ln { stroke-width: 2; }
      .dp-sl { stroke: var(--muted); stroke-width: 1; stroke-dasharray: 4 4; vector-effect: non-scaling-stroke;
        transform: translate(1px, calc(3px + (1 - var(--frac,0)) * (var(--tc-h,72) - 6) * 1px)) scaleX(calc(var(--tc-w,300) - 2)); }
      .dp-sl[data-quality=missing] { display: none; }
      /* The underway ladder's narrow wide cell: the numeral sized to the
         column (dashboard.css: 44 px at the 1024 floor, 68 px from ~1620). */
      html[data-slot=wide] .dp-r .rd-xl { font-size: clamp(44px, 27vw, 68px); }
    `),
  };
}
